import React, { ReactNode } from 'react';
import Box from 'ui-box';
import {
  defaultColors,
  defaultFills,
  Heading,
  majorScale,
  minorScale,
} from '../../npaper';
import { Logo } from '../Logo';

export const AuthBanner = ({ children }: { children?: ReactNode }) => {
  return (
    <Box
      background={`linear-gradient(-45deg, ${defaultColors.brand[800]} 0%, ${defaultColors.brand[900]} 100%)`}
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {children ? (
        children
      ) : (
        <Box>
          <Logo width={256} height={256} />
          <Box
            is="h1"
            fontSize="64px"
            color={defaultFills.brand[300]}
            lineHeight="80px"
            textAlign="center"
            marginTop={majorScale(2)}
          >
            sails
          </Box>
        </Box>
      )}
    </Box>
  );
};

export const AuthLayout = ({
  children,
  authBannerContent,
}: {
  children: ReactNode;
  authBannerContent?: ReactNode;
}) => (
  <Box display="grid" gridTemplateColumns="1fr 1fr" height="100%">
    <AuthBanner children={authBannerContent} />
    <Box maxHeight="100%" height="100%" overflowY="auto">
      <Box display="grid" height="100%">
        <Box
          margin="auto"
          maxWidth="300px"
          width="100%"
          paddingY={majorScale(10)}
        >
          {children}
        </Box>
      </Box>
    </Box>
  </Box>
);

export const AuthTitle = ({
  title,
  sub,
  description,
}: {
  title: string;
  sub: string;
  description?: string;
}) => (
  <Box marginBottom={majorScale(2)}>
    <Heading size={100}>{sub}</Heading>
    <Heading size={500} marginTop={minorScale(1)}>
      {title}
    </Heading>
    {description && (
      <Box is="p" className="muted" marginTop={minorScale(1)}>
        {description}
      </Box>
    )}
  </Box>
);
